<script lang="ts">
  import './_lib/init';

  import SvgSprite from '$lib/components/svg-sprite.svelte';

  import cillarIcon from '$lib/../assets/img/cillar-icon.svg?url';

  import {getParameterizedRoute} from '$lib/utils/routes';
  import {Route} from '$lib/enums/routes';

  import {
    GridColumn,
    GridWrap,
    GridColumnModifier,
    GridWrapModifier,
  } from '$lib/components/grid';

  import Auth from './_components/auth.svelte';
  import {
    Menus,
    MenuToggle,
    MenuState,
    MenuToggleModifier,
    getMenuToggles,
  } from './_components/menus';

  import {resolveStaticAssetPath} from '$lib/utils/components';

  import Header from './_components/header.svelte';
  import Footer from './_components/footer.svelte';

  const themeColor = '#78dea2';

  let menuState: MenuState = MenuState.Closed;

  function handleOutsideClick(event: Event) {
    const {target} = event;
    const element =
      target instanceof HTMLElement ? target : document.createElement('div');

    const toggleEl = getMenuToggles().find(
      (toggle) => element == toggle && toggle.contains(element),
    );

    if (!toggleEl && menuState === MenuState.Open) {
      toggleMenuState();
    }
  }

  function toggleMenuState() {
    menuState =
      menuState === MenuState.Closed ? MenuState.Open : MenuState.Closed;
  }
</script>

<svelte:head>
  <link rel="icon" href={resolveStaticAssetPath('favicon.svg')} />
  <link
    rel="mask-icon"
    href={resolveStaticAssetPath('favicon.svg')}
    color={themeColor}
  />
  <meta name="theme-color" content={themeColor} />
</svelte:head>

<SvgSprite />
<Auth />

<div
  class="application-layout"
  data-css-menu-state={menuState}
  on:click={handleOutsideClick}
  on:touchstart={handleOutsideClick}
>
  <nav class="application-layout__secondary">
    <div class="application-layout__secondary__header">
      <GridWrap
        modifiers={[GridWrapModifier.NoGutter, GridWrapModifier.Middle]}
      >
        <GridColumn modifiers={[GridColumnModifier.Auto]}>
          <a href={getParameterizedRoute(Route.Home)}>
            <img src={cillarIcon} alt="" />
          </a>
        </GridColumn>

        <GridColumn modifiers={[GridColumnModifier.ShrinkWrap]}>
          <MenuToggle on:click={toggleMenuState} state={menuState} />
        </GridColumn>
      </GridWrap>
    </div>

    <Menus />
  </nav>

  <div class="application-layout__primary">
    <div class="application-layout__primary__header">
      <Header>
        <MenuToggle
          modifiers={[MenuToggleModifier.Base]}
          on:click={toggleMenuState}
          state={menuState}
        />
      </Header>
    </div>

    <main class="application-layout__primary__content">
      <div class="area-header--portable" />

      <slot />
    </main>

    <div class="application-layout__primary__footer">
      <Footer />
    </div>
  </div>
</div>

<style lang="scss" global>
  @import '../assets/css/style.scss';
</style>
